import { Injectable, inject } from "@angular/core";
import { EventEmitter } from "@angular/core";
import { Observable, of } from "rxjs";
import { OidcSecurityService } from "angular-auth-oidc-client";
import { APP_SETTINGS, AppSettings } from "src/app/app.settings";


@Injectable({
    providedIn: "root"
})

export class UserInfoService {
    private env = inject<AppSettings>(APP_SETTINGS);
    private oidcSecurityService = inject(OidcSecurityService);


    private userInfoAdded: EventEmitter<UserInfo> = new EventEmitter<UserInfo>();
    private userInfo: UserInfo | undefined;

    public authorize() {
        this.oidcSecurityService.checkAuth().subscribe(loginResponse => {
            const { isAuthenticated, userData, accessToken, idToken, configId } = loginResponse;

            if (!isAuthenticated) {
                this.oidcSecurityService.authorize();
            }
            else {
                this.setUserInfo(userData);
            }
        });
    }


    private setUserInfo(userData: any): void {
        this.userInfo = new UserInfo();
        this.userInfo.id = userData["sub"];
        this.userInfo.name = `${userData["given_name"]} ${userData["family_name"]}`.trim();
        this.userInfo.firstName = `${userData["given_name"]}`.trim();
        this.userInfo.lastName = `${userData["family_name"]}`.trim();
        this.userInfo.fullName = (this.userInfo.firstName + " " + this.userInfo.lastName).trim();
        this.userInfo.hsaid = userData["hsaid"];
        this.userInfo.unit = userData["unit_name"];
        this.userInfo.unitId = userData["unit_id"];
        this.userInfo.email = userData["email"];
        this.userInfo.isAuthenticated = (this.userInfo.id != "");

        //if ("permissions" in userData)
        //    this.userInfo.permissions = (userData["permissions"] as string).split(",").map(s => parseInt(s));

        //if ("role_name" in userData) {
        //    this.userInfo.roles = userData["role_name"];
        //}

        //this.userInfo.isAdmin = this.userInfo.hasPermission(Permissions.System, Permissions.Support, Permissions.Grupp);

        this.userInfoAdded.emit(this.userInfo);
    }

    public getUserInfo(): Observable<UserInfo> {
        if (this.userInfo)
            return of(this.userInfo);

        return this.userInfoAdded;
    }

    logout() {
        this.clearApps();
        sessionStorage.setItem("signoutRedirect", this.env.authConfig.authority + "/account/logout");
        this.oidcSecurityService.logoffAndRevokeTokens().subscribe();
    }


    changeUnit() {
        this.clearApps();
        sessionStorage.setItem("signoutRedirect", "/");
        this.oidcSecurityService.logoffAndRevokeTokens().subscribe();
    }


    private clearApps() {
        const app = "0-" + this.env.authConfig.clientId;
        Object.keys(sessionStorage).forEach((key) => {
            console.log(key);
            if (key != app && key.startsWith("0-")) {
                sessionStorage.removeItem(key);
            }
        });
    }

}


export class UserInfo {
    isAuthenticated = false;
    id = "";
    name = "";
    firstName = "";
    lastName = "";
    fullName = "";
    unit = "";
    unitId = 0;
    hsaid = "";
    email = "";
    isAdmin = false;
    roles?: [];
}
